import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import de from "./locales/de.json";
import en from "./locales/en.json";

export const LANG_STORAGE_KEY = "omselected-lang";
export type AppLocale = "de" | "en";
export const SUPPORTED: AppLocale[] = ["de", "en"];

export function detectInitialLocale(): AppLocale {
  if (typeof window === "undefined") return "de";
  try {
    const stored = window.localStorage.getItem(LANG_STORAGE_KEY);
    if (stored === "de" || stored === "en") return stored;
  } catch {}
  return "de";
}

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources: {
      de: { translation: de },
      en: { translation: en },
    },
    lng: "de",
    fallbackLng: "de",
    supportedLngs: SUPPORTED,
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });
}

export function setLocale(loc: AppLocale) {
  i18n.changeLanguage(loc);
  try {
    window.localStorage.setItem(LANG_STORAGE_KEY, loc);
  } catch {}
  if (typeof document !== "undefined") {
    document.documentElement.lang = loc;
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event("omselected-lang-change"));
  }
}

export default i18n;